import React from 'react';
import { FluxoDeCaixaContent } from './FluxoDeCaixaContent';
import { FluxoDeCaixaProvider } from './context/FluxoDeCaixaContext';

export const FluxoDeCaixa: React.FC = () => {
  return (
    <FluxoDeCaixaProvider>
      <FluxoDeCaixaContent />
    </FluxoDeCaixaProvider>
  );
};
